import { useState, type FormEvent } from "react";
import { Link } from "react-router";
import { motion } from "motion/react";
import { api, useAction } from "../api.ts";
import { Button, ErrorText, Field, Icon, Input } from "../ui/index.tsx";
import { AuthLayout } from "../layouts.tsx";
import { authItem } from "./Login.tsx";
import type { ForgotPasswordRequest, ForgotPasswordResponse } from "../../shared/types.ts";

export default function Forgot() {
  const [ident, setIdent] = useState("");
  const [sent, setSent] = useState<string | null>(null);

  const submit = useAction(async () => {
    const body: ForgotPasswordRequest = { username_or_email: ident.trim() };
    setSent((await api.post<ForgotPasswordResponse>("/auth/forgot", body)).message);
  });

  const onSubmit = (e: FormEvent) => { e.preventDefault(); void submit.run(); };

  return (
    <AuthLayout title="Forgot your password?"
      subtitle="Enter your username or the email on your account and we'll send a reset link."
      footer={<Link to="/login" className="text-accent hover:underline">Back to sign in</Link>}>
      {sent ? (
        <motion.div variants={authItem} className="space-y-3" role="status">
          <div className="flex items-start gap-3 rounded-lg border border-ok/30 bg-ok/10 px-3 py-3 text-sm text-ok">
            <Icon name="check" className="mt-0.5 size-4 shrink-0" />
            <span>{sent}</span>
          </div>
          <p className="text-xs text-faint">Reset links are only sent to a verified email address.</p>
        </motion.div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <motion.div variants={authItem}>
            <Field label="Username or email">
              <Input autoComplete="username" autoFocus required maxLength={320} value={ident} onChange={(e) => setIdent(e.target.value)} />
            </Field>
          </motion.div>
          <div role="alert" className="empty:hidden"><ErrorText>{submit.error}</ErrorText></div>
          <motion.div variants={authItem}>
            <Button type="submit" variant="primary" size="lg" className="w-full" loading={submit.pending}>Send reset link</Button>
          </motion.div>
        </form>
      )}
    </AuthLayout>
  );
}
